import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { DocumentationLink } from "components/support";
import DocsHelper from "util/DocsHelper";
import useSearchVersionCheck from "hooks/useSearchVersionCheck";
import { ExternalLink } from "components/common";
const WarmTierSnapshotsText = () => {
  const { t } = useTranslation("enterprise_data_tiering");
  const { data, isLoading } = useSearchVersionCheck("datanode");
  const showDataNodeText = !isLoading && (data == null ? void 0 : data.satisfied);
  return /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: showDataNodeText ? "snapshots.data_node" : "snapshots.at_least_one_node",
      components: {
        searchRoleLink: /* @__PURE__ */ React.createElement(ExternalLink, { href: "https://docs.opensearch.org/docs/latest/security/access-control/users-roles/" }),
        docsLink: /* @__PURE__ */ React.createElement(
          DocumentationLink,
          {
            page: DocsHelper.PAGES.DATA_TIERING_WARM_TIER_SETUP,
            text: t("snapshots.docs_link_text")
          }
        )
      }
    }
  ));
};
export default WarmTierSnapshotsText;
